/**
 * 业务第三方插件类
 * ```
 * Plugin.setConfig({
 *    timeout: 5000,
 *    alias: {
 *       jiuwo: 'http://misc.xl9.xunlei.com/client/static/1.0/js/page/dev/modules/jiuwo.js',
 *    }
 * });
 *
 * Plugin.use('jiuwo', function(){
 *    // 成功回调
 * },function(){
 *    // 失败回调
 * }); 
 * ``` 
 * 
 * @class Plugin
 * @param id {string} 插件别名或者插件的url
 * 
 */

function Plugin(id) {
    var id = getPluginID(id);
    Plugin.store[id] = this;

    /**
     * 插件实例的id
     * @property Plugin.id
     * @type String
     */
    this.id = id;

    /**
     * 插件实例的依赖
     * @property Plugin.deps
     * @type Array
     * @default []
     */
    this.deps = [];

    /**
     * 插件实例依赖注入的实例
     * @property Plugin.depsInstance
     * @type Object
     * @default []
     */
    this.depsInstance = [];

    /**
     * 插件实例的工厂方法
     * @method Plugin.factory
     * @default function(){}
     */
    this.factory = function () {
    };

    /**
     * 插件实例的状态
     * @property Plugin.status
     * @type Number
     * @default 0
     */
    this.status = Plugin.STATUS.PENDDING;

    /**
     * 插件实例的回调函数
     * @property Plugin.callbacks
     * @type Object
     * @default {} 
     */
    this.callbacks = {};

    // 启动插件
    this.load();
}

/**
 * 加载插件的方法
 * @method Plugin.prototype.load
 */
Plugin.prototype.load = function () {
    var id = this.id;
    var self = this;
    var script = document.createElement('script');
    script.async = true;
    // 开启后需要插件js设置Access-Control-Allow-Origin
    // script.setAttribute("crossorigin", 'true')
    script.src = id;
    script.onerror = function (event) {
        this.setStatus(Plugin.STATUS.ERROR, {
            id: id,
            error: (this.error = new Error('Plugin can not load.'))
        });
    }.bind(this);
    this.timmer = setTimeout(function(){
        if (self.status !== Plugin.STATUS.COMPLETED) {
            self.setStatus(Plugin.STATUS.ERROR, {
                id: id,
                error: (self.error = new Error('Plugin load timeout'))
            });
        }
    }, Plugin.config.timeout);
    document.body.appendChild(script);
    this.setStatus(Plugin.STATUS.LOADING);
}

/**
 * 插件的事件监听器
 * @method Plugin.prototype.on
 * @param event　{string} 事件名称（load | complete | error）
 * @param callback {function} 回调函数
 */
Plugin.prototype.on = function (event, callback) {
    (this.callbacks[event] || (this.callbacks[event] = [])).push(callback);
    if (
        (this.status === Plugin.STATUS.LOADING && event === 'load') ||
        (this.status === Plugin.STATUS.COMPLETED && event === 'complete')
    ) {
        callback(this);
    }
    if (this.status === Plugin.STATUS.ERROR && event === 'error') {
        callback(this, this.error);
    }
    return this;
}

/**
 * 插件的事件触发器
 * @method Plugin.prototype.fire
 * @param event　{string} 事件名称（load | complete | error）
 * @param arg {any} 参数
 */
Plugin.prototype.fire = function (event, arg) {
    (this.callbacks[event] || []).forEach(function (callback) {
        callback(arg || this);
    }.bind(this));
}

/**
 * 插件的状态管理方法
 * @method Plugin.prototype.setStatus
 * @param status {number} 新状态
 * @param info {any} 其他信息
 */
Plugin.prototype.setStatus = function (status, info) {
    if (this.status !== status) {
        this.status = status;
        switch (status) {
            case Plugin.STATUS.LOADING:
                this.fire('load');
                break;
            case Plugin.STATUS.COMPLETED:
                this.fire('complete');
                clearTimeout(this.timmer);
                break;
            case Plugin.STATUS.ERROR:
                this.fire('error', info);
                clearTimeout(this.timmer);
                break;
            default:
                break;
        }
    }
}

/**
 * 所有插件的存储空间
 * @property Plugin.store
 * @static
 * @type {object}
 * @default {}
 */
Plugin.store = {};

/**
 * 插件的所有状态
 * @property Plugin.STATUS
 * @static
 * @type Object
 */
Plugin.STATUS = {
    PENDDING: 0,
    LOADING: 1,
    COMPLETED: 2,
    ERROR: 3
};

/**
 * 插件配置项
 * @property Plugin.config
 * @static
 * @type {object}
 */
Plugin.config = {
    timeout: 5000,
    alias: {}
}

/**
 * 设置插件配置项
 * @method Plugin.setConfig
 * @static 
 * @param config {object} 配置对象
 * @example
 * ```
 * Plugin.setConfig({
 *     alias: {
 *         jiuwoZhibo: 'http://192.168.21.139:3000/client/static/1.0/js/page/dev/modules/jiuwo.js',
 *     }
 * });

 * Plugin.use('jiuwoZhibo',function (exports) {
 *     console.log(exports);
 * },function (error) {
 *     $('[data-plugin="jiuwoZhibo"]').remove();
 * });
 * ```
 */
Plugin.setConfig = function (config) {
    for (var key in config) {
        this.config[key] = config[key];
    }
};

/**
 * 使用某个插件
 * @method Plugin.use
 * @static
 * @param id　{string} 插件的别名或者url
 * @param sucCallback {function} 成功的回调函数
 * @param errCallback {function} 失败的回调函数
 * @example
 * ```
 * Plugin.use('http://meitu.xunlei.com/js/xl9meitu.js', function (meitu) {   
 *     // 加载插件成功时的回调函数
 * }, function(errCallback){
 *     // 加载插件失败时的回调函数
 * })
 * ```
 */
Plugin.use = function (id, sucCallback, errCallback) {
    var ID = getPluginID(id);
    var plugin = (Plugin.store[ID] || new Plugin(id));

    plugin
        .on('complete', function () {
            var exp = plugin.exports;
            if (typeof sucCallback === 'function') {
                sucCallback(exp);
            }
        })
        .on('error', function (error) {
            if (typeof errCallback === 'function') {
                errCallback(error);
            }
        });
};

/**
 * 第三方业务定义自己对应的依赖和工厂方法
 * @method Plugin.definePlugin
 * @static
 * @params [pluginId=''] {string} 插件名,可选
 * @param [deps=[]] {array}　依赖列表，可选
 * @param factory {function}　工厂方法
 * @example
 * ```
 *  Plugin.definePlugin([ 'xl9' ], function(xl9){
 *      // you code here
 *  })
 * ```
 */
Plugin.definePlugin = function () {
    var pluginId = '';
    var deps = [];
    var factory = function () { };
    _getArgs(arguments);

    var id = getCurrentScript();
    var plugin = Plugin.store[id];
    var args = [];
    plugin.deps = deps;
    plugin.factory = factory;


    deps.forEach(function (dep) {
        var arg = null;
        switch (dep) {
            case 'xl9':
                var XL9 = require('./xl9_open_api');
                arg = new XL9();
                break;
            default:
                break;
        }
        args.push(arg);
    });
    plugin.depsInstance = args;
    plugin.exports = plugin.factory.apply(null, args);
    plugin.setStatus(Plugin.STATUS.COMPLETED);

    function _getArgs(args) {
        for (var i = 0; i < args.length; i++) {

            switch (typeof args[i]) {
                case 'string':
                    pluginId = args[i];
                    break;
                case 'object':
                    deps = args[i];
                    break;
                case 'function':
                    factory = args[i];
                    break;
            }
        };

    }
};


/**
 * 获取当前执行的script节点
 * @method getCurrentScript
 * @private
 */
function getCurrentScript() {
    var doc = document;
    if (doc.currentScript) {
        return doc.currentScript.src;
    }
    var stack;
    try {
        a.b.c();
    } catch (e) {
        stack = e.stack;
        if (!stack && window.opera) {
            stack = (String(e).match(/of linked script \S+/g) || []).join(" ");
        }
    }
    if (stack) {
        stack = stack.split(/[@ ]/g);
        var globalIndex = stack.indexOf('Global');
        if (globalIndex !== -1) {
            stack = stack[globalIndex + 2];
        } else {
            stack = stack.pop();
        }
        stack = stack.replace(/\n/g, '');
        stack = stack[0] == "(" ? stack.slice(1, -1) : stack;
        return stack.replace(/(:\d+)?:\d+$/i, "");
    }
    var nodes = doc.body.getElementsByTagName("script");
    for (var i = 0, node; node = nodes[i++];) {
        if (node.readyState === "interactive") {
            return node.className = node.src;
        }
    }
}

/**
 * 获取插件id
 * @method getPluginID
 * @param id {string} 插件别名或者url
 * @return {string} 插件的id
 */
function getPluginID(id) {
    if (id in Plugin.config.alias) {
        return Plugin.config.alias[id];
    } else {
        return id;
    }
}

module.exports = Plugin;


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/plugin.js
// module id = 7
// module chunks = 1 2 3 5 6 7 8 9 10 11 12